import cn from "classnames";
import Bid from "components/bids/item";
import { dateTimeInUtcOffset, dateTimeToView, formatUtcOffset } from "helpers/date";
import { documentsTrackingStatuses, documentsTrackingStatusesEnum } from "helpers/enums";
import { enumLabel } from "helpers/system";
import moment from "moment";
import React from "react";
import { updateParcelStatus } from "sources/parcel";
import TrackingModal from "./trackingModal";

export default class DocumentTrackingBid extends Bid {
    state = {
        statusUpdating: false,
    };

    get parcels() {
        return this.props.item.parcels || [];
    }

    getLastStatusFixedAt = () => {
        return this.parcels
            .map((parcel) => parcel.fixedAt || parcel.status?.fixedAt)
            .filter(Boolean)
            .sort((prev, next) => new Date(next) - new Date(prev))[0];
    };

    stopStatusAction = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    openTrackingModal = (e) => {
        this.stopStatusAction(e);

        this.props.modal({
            name: "default",
            title: "Редактировать отправление",
            windowMod: "sm",
            CustomBody: TrackingModal,
            bodyData: {
                bid: this.props.item,
                getList: this.props.getList,
                params: this.props.params,
            },
        });
    };

    updateStatuses = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const parcelIds = this.parcels.map(({ id }) => id).filter(Boolean);

        if (!parcelIds.length || this.state.statusUpdating) {
            return;
        }

        this.setState({ statusUpdating: true });
        Promise.all(parcelIds.map((id) => updateParcelStatus({ id })))
            .then(() => this.props.getList?.(this.props.params))
            .catch(() => undefined)
            .finally(() => this.setState({ statusUpdating: false }));
    };

    getManualStatusData = () => {
        const { documentsTrackingStatus, plannedArrivalDate, documentsReceiptDate } = this.props.item.payment ?? {};
        const status = documentsTrackingStatus || documentsTrackingStatusesEnum.NotShipped;
        const statusClass = {
            [documentsTrackingStatusesEnum.NotShipped]: "badge-secondary",
            [documentsTrackingStatusesEnum.InTransit]: "badge-dark",
            [documentsTrackingStatusesEnum.Delivered]: "badge-success",
        }[status];

        return {
            status: <span className={cn("badge", statusClass)}>{enumLabel(documentsTrackingStatuses, status)}</span>,
            dates: [
                plannedArrivalDate && `Прибытие: ${moment(plannedArrivalDate).format("DD.MM.YYYY")}`,
                documentsReceiptDate && `Получено: ${moment(documentsReceiptDate).format("DD.MM.YYYY")}`,
            ].filter(Boolean),
        };
    };

    renderStatus = () => {
        let status;
        let manualDates = [];
        if (!this.parcels.length) {
            const manualStatus = this.getManualStatusData();
            status = manualStatus.status;
            manualDates = manualStatus.dates;
        } else {
            const isFinal = this.parcels.every((item) => !!item.status?.isFinal);

            status = isFinal ? (
                <span className="badge badge-success">Доставлено</span>
            ) : (
                <span className="badge badge-dark">В пути</span>
            );
        }
        const fixedAt = this.getLastStatusFixedAt();
        const { organizationTimezone } = this.props;
        const organizationUtcOffset = formatUtcOffset(organizationTimezone);

        return (
            <>
                {status}
                {fixedAt && (
                    <div className="small text-muted mt-1 text-nowrap">
                        {dateTimeToView(dateTimeInUtcOffset(fixedAt, organizationUtcOffset))}&nbsp;
                        {organizationUtcOffset && `(${organizationUtcOffset})`}
                    </div>
                )}
                {manualDates.map((item) => (
                    <div key={item} className="small text-muted mt-1 text-nowrap">
                        {item}
                    </div>
                ))}
                {this.parcels.length > 0 && (
                    <div className="mt-1" onClick={this.stopStatusAction} onMouseDown={this.stopStatusAction}>
                        <button
                            type="button"
                            className={cn("btn btn-xs btn-outline-primary text-nowrap", {
                                disabled: this.state.statusUpdating,
                            })}
                            disabled={this.state.statusUpdating}
                            onClick={this.updateStatuses}
                        >
                            <i className="icon-uEAB3-arrows-rotate pr-1" />
                            {this.state.statusUpdating ? "Обновляется" : "Обновить статус"}
                        </button>
                    </div>
                )}
                <div className="mt-1" onClick={this.stopStatusAction} onMouseDown={this.stopStatusAction}>
                    <button
                        type="button"
                        className="btn btn-xs btn-outline-primary text-nowrap"
                        onClick={this.openTrackingModal}
                    >
                        Редактировать отправление
                    </button>
                </div>
            </>
        );
    };
}
